import React,{useRef,useState} from 'react'
import {Link,useHistory} from 'react-router-dom'
import {useAuth} from './AuthContext'
import swal from 'sweetalert'
import './Forgot.css'
export default function Forgotpassword() {
    const emailRef=useRef()
    const [loding,setLoading]=useState(false);
    const {forgot} =useAuth()
    const [error,setError]=useState();
    async function handleSubmit(e){
        e.preventDefault();
        try{
            setError('')
            setLoading(true)
            await forgot(emailRef.current.value)
            swal("Cheack your mail")
        }catch (err){
			setError(err.message)
			swal({
                title:"unable to Reset ",
                text:"enter valid mail or password",
                icon:"warning",
                button:"ok",
            })
        }
        setLoading(false)
    }

    return (
        <div id="flexx">
            <div id="forgotCont">
                <form>
                <input type="email" ref={emailRef} placeholder="E-mail"></input><br/>
                <button disabled={loding} onClick={handleSubmit}>Reset</button>
                <Link to="/login">Log in</Link>
                </form>
            </div>
        </div>
    )
}
